
import { Component } from "react";
import { Button, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import Select from 'react-select'
import axiosInstance from "../../../axiosInstance";
import { generateErrorMessage, make_select_data } from "../../helper";




const ticket_owner_actions = [
    { value: 1, label: 'ჩამატება' },
    { value: 2, label: 'წაშლა' },
]
const default_action = { value: 1, label: 'ჩამატება' };

class NewDashboardSetting extends Component {


    constructor() {
        super();
        this.state = {
            selected_type: null,
            selected_stage: null,
            role_id: null,
            next_selected_stage: null,
            action: null,
            user_only: false,
            types_array: [],
            stages_array: [],
            roles_array: [],
            actions_array: [],
            errors:{
                selected_type : false,
                selected_stage: false,
                role_id : false,
                next_selected_stage:false,
                action :false,
                user_only:false
            },
            error_messages:{
                selected_type : 'გთხოვთ აირჩიეთ ტიპი',
                selected_stage: 'გთხოვთ აირჩიეთ მდგომარეობა',
                role_id : 'გთხოვთ აირჩიეთ როლი',
                next_selected_stage:'გთხოვთ აირჩიეთ შემდეგი მდგომარეობა',
                action :'გთხოვთ აირჩიეთ მოქმედება',
                user_only:'გთხოვთ აირჩიოთ'
            },
            response : {
                isValid : false,
                isInValid:false,
                message : 'პარამეტრი წარმატებით ჩაემატა'
            }
        }
    }
    componentDidMount() {
        this.fetch_roles();
        this.fetch_types();
        this.fetch_stages();
    }

    fetch_types() {
        axiosInstance.get('/tickets/types')
            .then(response => {
                this.setState({
                    types_array: make_select_data(response.data.data)
                })
            })
            .catch(error => {

            });
    }

    fetch_roles() {
        axiosInstance.get('/roles')
            .then(response => {
                this.setState({
                    roles_array: make_select_data(response.data.data)
                })
            })
            .catch(error => {

            });
    }

    fetch_stages() {
        axiosInstance.get('/tickets/stages')
            .then(response => {
                this.setState({
                    stages_array: make_select_data(response.data.data)
                })
            })
            .catch(error => {

            });
    }
    add_setting() {
        if(!this.isValid())return;
        axiosInstance.post('tickets/dashboard/permissions',{
            type_id:this.state.selected_type.value,
            stage_id:this.state.selected_stage.value,
            role_id:this.state.role_id.value,
            next_stage_id:this.state.next_selected_stage ? this.state.next_selected_stage.value :  null,
            ticket_owner_action_id:this.state.action ?this.state.action.value : null,
            user_only:this.state.user_only
        })
        .then(response => {
            this.setState({
                selected_type:null,
                selected_stage:null,
                role_id:null,
                next_selected_stage:null,
                action:null,
                user_only:false,
            })
        })
        .catch(error => {
            if(error.response?.status == 400 || error.response?.status == 422){
                this.on_bad_request(error);
            }
        })
    }

    on_bad_request(error){
        let message = generateErrorMessage(error.response.data.errors);
        this.setState({
            response:{
                ...this.state.response,
                isInValid:true,
                message:message
            }
        })
    }


    isValid(){
        let selected_type = this.state.selected_type == null;
        let selected_stage = this.state.selected_stage == null;
        let role_id = this.state.role_id == null;
        if(selected_stage || selected_type || role_id ){
            this.setState({
                errors:{
                    selected_type : selected_type,
                    selected_stage: selected_stage,
                    role_id : role_id
                }
            })
            return false;
        }
        return true;
    }

    render() {
        return (
            <div className="content-main">
                <Form.Row>
                        <Form.Group as={Col}  md="4" >
                            <Form.Control
                                    type="text"
                                    name="role"
                                    hidden = {true}
                                    isInvalid = {Boolean(this.state.response.isInValid)}
                                    isValid = {Boolean(this.state.response.isValid)}
                                    onChange = {null}
                                />
                            <Form.Control.Feedback type="invalid" >
                                {this.state.response.message}
                            </Form.Control.Feedback>

                            <Form.Control.Feedback >
                                {this.state.response.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={12} md={5} >
                        <Form.Label>ტიპი</Form.Label>
                        <Form.Control
                            hidden={true}
                            isInvalid={this.state.errors.selected_type}
                        />
                        <Select
                            value={this.state.selected_type}
                            options={this.state.types_array}
                            onChange={(e) => {
                                this.setState({
                                    selected_type: e
                                })
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {this.state.error_messages.selected_type}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={12} md={5} >
                        <Form.Label>მდგომარეობა</Form.Label>
                        <Form.Control
                            hidden={true}
                            isInvalid={this.state.errors.selected_stage}
                        />
                        <Select
                            value={this.state.selected_stage}
                            options={this.state.stages_array}
                            onChange={(e) => {
                                this.setState({
                                    selected_stage: e
                                })
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {this.state.error_messages.selected_stage}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={12} md={5} >
                        <Form.Label>როლი</Form.Label>
                        <Form.Control
                            hidden={true}
                            isInvalid={this.state.errors.role_id}
                        />
                        <Select
                            value={this.state.role_id}
                            options={this.state.roles_array}
                            onChange={(e) => {
                                this.setState({
                                    role_id: e
                                })
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {this.state.error_messages.role_id}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={12} md={5} >
                        <Form.Label>შემდეგი მდგომარეობა</Form.Label>
                        <Form.Control
                            hidden={true}
                            isInvalid={this.state.errors.next_selected_stage}
                        />
                        <Select
                            value={this.state.next_selected_stage}
                            options={this.state.stages_array}
                            onChange={(e) => {
                                this.setState({
                                    next_selected_stage: e
                                })
                            }}

                        />
                        <Form.Control.Feedback type="invalid">
                            {this.state.error_messages.next_selected_stage}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group as={Col} sm={12} md={5} >
                        <Form.Label>მოქმედება</Form.Label>
                        <Form.Control
                            hidden={true}
                        />
                        <Select
                            options={ticket_owner_actions}
                            onChange={(e) => {
                                this.setState({
                                    action: e
                                })
                            }}

                        />
                    </Form.Group>
                </Form.Row>
                <Form.Row>
                    <Form.Group >
                        <Form.Check type="checkbox" label="user only" onChange={(e) => {
                            this.setState({
                                user_only: e.target.checked
                            })
                        }} />
                    </Form.Group>
                </Form.Row>
                <Link to="/dashboard_settings" id="btn-back" className="btn btn-dark" >უკან დაბრუნება</Link>
                <Button className="btn btn-success" size="md" onClick={(event) => this.add_setting(event)}>დამატება</Button>
            </div>
        )
    }
}

export default NewDashboardSetting;